import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../../../css/wallet/Token/DepositToken.css";
import { bankAccountAdditionRequest } from "./BankAccountsAdditionRequest.js";

function AddBankAccounts({ theme, setAddBankAccountsStatus, setData }) {
  const translationSession = sessionStorage.getItem("translation");
  const { t, i18n } = useTranslation();
  
  const [active, setActive] = useState(false);

  const navigate = useNavigate();

  const [nameInputValue, setNameInputValue] = useState("");
  const [cardNumberValue, setCardNumberValue] = useState("");
  const [cardNumber2Value, setCardNumber2Value] = useState("");

  const [requestStatus, setRequestStatus] = useState(false);

  useEffect(() => {
    if (translationSession) {
      i18n.changeLanguage(translationSession);
    }

    setActive(true);
  }, [translationSession, i18n]);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setAddBankAccountsStatus(false);
          }, 150);
        }}
      ></div>
      <div className={`popupMainDiv noPadding ${theme} ${active && "active"}`}>
        <div className={`popupHeaderDiv ${theme}`}>
          {t("add Bank Accounts")}
        </div>

        <div className="popupContentDiv">
          <div className="inputDiv">
            <div>{t("Name")}</div>
            <input
              className={`input ${theme}`}
              dir="auto"
              onChange={(e) => {
                setNameInputValue(e.target.value);
              }}
            ></input> 
          </div>
          <div className="inputDiv">
            <div>{t("Card Number")}</div>
            <input
              className={`input dir_ltr ${theme}`}
              onChange={(e) => {
                setCardNumberValue(e.target.value);
              }}
            ></input>
          </div>

          <div className="inputDiv">
            <div>{t("Card Number 2")}</div>
            <input
              className={`input dir_ltr ${theme}`}
              onChange={(e) => {
                setCardNumber2Value(e.target.value);
              }}
            ></input>
          </div>

          <button
            className={`submitButton ${theme} ${nameInputValue.length > 0 && cardNumberValue.length > 0 && "active"}`}
            onClick={() => {
              if (nameInputValue.length > 0 && cardNumberValue.length > 0) {
                bankAccountAdditionRequest(
                  nameInputValue,
                  cardNumberValue,
                  cardNumber2Value,
                  setRequestStatus,
                  setData,
                  setAddBankAccountsStatus,
                );
              }
            }}
          >
            {requestStatus ? (
              <img src="/icons/loading.png" className={`rotate icon ${theme}`}></img>
            ) : (
              t("Submit")
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default AddBankAccounts;
